/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Is_EuInputs */

const en_reference_field_is_eu = /** @type {(inputs: Reference_Field_Is_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the EU`)
};

/**
* | output |
* | --- |
* | "In the EU" |
*
* @param {Reference_Field_Is_EuInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_is_eu = /** @type {((inputs?: Reference_Field_Is_EuInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Is_EuInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_is_eu(inputs)
});